module.exports = __webpack_public_path__ + "static/sport/logo.5137446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/logo.png
// module id = A7/O
// module chunks = 0